// @flow weak

import React, {
  Component
}                               from 'react';
import {
  // Router, // using now ConnectedRouter from react-router-redux v5.x (the only one compatible react-router 4)
  Switch,
  Route
}                               from 'react-router-dom';
import { ConnectedRouter }      from 'react-router-redux';
import { Provider }             from 'react-redux';
import configureStore           from './redux/store/configureStore';
import { history }              from './redux/store/configureStore';
import App                      from './containers/app';
import ScrollTop                from './components/scrollToTop/ScrollToTop';
import Login                    from './views/login';
import PageNotFound             from './views/pageNotFound';


//import { history } from './_helpers/history';
//import { alertActions } from './redux/_actions/alert.actions';
//import { userActions } from './redux/_actions/user.actions';
//import { connect } from 'react-redux';
// #region flow types
type Props = any;
type State = any;

// #endregion
console.log = function() {};
console.warn = function() {};
console.error = function() {};
const store = configureStore();
//store.dispatch(actions.setTracks(tracks));

class Root extends Component<Props, State> {


  render() {
    
    return (
      <Provider store={store}>
        <div>
     
          <ConnectedRouter history={history}>
            <ScrollTop>
              <Switch>
                <Route exact path="/" component={Login} />
                <App />
                <Route component={PageNotFound} />
                {/* <PrivateRoute path="/protected" component={ProtectedConnected} /> */}
              </Switch>
            </ScrollTop>
          </ConnectedRouter>
        </div>
      </Provider>
    );
  }
}

export default Root;


// WEBPACK FOOTER //
// ./src/app/Root.js